"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("events");
var storage_1 = require("./storage");
var url_1 = require("url");
var request_1 = require("./request");
var Repository = /** @class */ (function (_super) {
    __extends(Repository, _super);
    function Repository(_a) {
        var backupPath = _a.backupPath, url = _a.url, appName = _a.appName, instanceId = _a.instanceId, refreshInterval = _a.refreshInterval, _b = _a.StorageImpl, StorageImpl = _b === void 0 ? storage_1.Storage : _b, timeout = _a.timeout, headers = _a.headers, customHeadersFunction = _a.customHeadersFunction;
        var _this = _super.call(this) || this;
        _this.stopped = false;
        _this.url = url;
        _this.refreshInterval = refreshInterval;
        _this.instanceId = instanceId;
        _this.appName = appName;
        _this.headers = headers;
        _this.timeout = timeout;
        _this.customHeadersFunction = customHeadersFunction;
        _this.storage = new StorageImpl({ backupPath: backupPath, appName: appName });
        _this.storage.on('error', function (err) { return _this.emit('error', err); });
        _this.storage.on('ready', function () { return _this.emit('ready'); });
        process.nextTick(function () { return _this.fetch(); });
        return _this;
    }
    Repository.prototype.timedFetch = function () {
        var _this = this;
        if (this.refreshInterval != null && this.refreshInterval > 0) {
            this.timer = setTimeout(function () { return _this.fetch(); }, this.refreshInterval);
            if (process.env.NODE_ENV !== 'test') {
                this.timer.unref();
            }
        }
    };
    Repository.prototype.validateFeature = function (feature) {
        var errors = [];
        if (!Array.isArray(feature.strategies)) {
            errors.push("feature.strategies should be an array, but was " + typeof feature.strategies);
        }
        if (feature.variants && !Array.isArray(feature.variants)) {
            errors.push("feature.variants should be an array, but was " + typeof feature.variants);
        }
        if (typeof feature.enabled !== 'boolean') {
            errors.push("feature.enabled should be an boolean, but was " + typeof feature.enabled);
        }
        if (errors.length > 0) {
            var err = new Error(errors.join(', '));
            this.emit('error', err);
        }
    };
    Repository.prototype.fetch = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, headers, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.stopped) {
                            return [2 /*return*/];
                        }
                        url = url_1.resolve(this.url, './client/features');
                        if (!this.customHeadersFunction) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.customHeadersFunction()];
                    case 1:
                        _a = _b.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = this.headers;
                        _b.label = 3;
                    case 3:
                        headers = _a;
                        request_1.get({
                            url: url,
                            etag: this.etag,
                            appName: this.appName,
                            timeout: this.timeout,
                            instanceId: this.instanceId,
                            headers: headers,
                        }, function (error, res, body) {
                            // start timer for next fetch
                            _this.timedFetch();
                            if (error) {
                                return _this.emit('error', error);
                            }
                            if (res.statusCode === 304) {
                                // No new data
                                _this.emit('unchanged');
                                return;
                            }
                            if (!(res.statusCode >= 200 && res.statusCode < 300)) {
                                return _this.emit('error', new Error("Response was not statusCode 2XX, but was " + res.statusCode));
                            }
                            try {
                                var data = JSON.parse(body);
                                var obj = data.features.reduce(function (o, feature) {
                                    _this.validateFeature(feature);
                                    o[feature.name] = feature;
                                    return o;
                                }, {});
                                _this.storage.reset(obj);
                                _this.etag = Array.isArray(res.headers.etag)
                                    ? res.headers.etag.join(' ')
                                    : res.headers.etag;
                                _this.emit('changed', _this.storage.getAll());
                            }
                            catch (err) {
                                _this.emit('error', err);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Repository.prototype.stop = function () {
        this.stopped = true;
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.removeAllListeners();
        this.storage.removeAllListeners();
    };
    Repository.prototype.getToggle = function (name) {
        return this.storage.get(name);
    };
    Repository.prototype.getToggles = function () {
        var toggles = this.storage.getAll();
        return Object.keys(toggles).map(function (key) { return toggles[key]; });
    };
    return Repository;
}(events_1.EventEmitter));
exports.default = Repository;
//# sourceMappingURL=repository.js.map